var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-6"},[_c('v-form',{ref:"form"},[_c('v-row',[_c('v-col',[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.form.reden.label)))]),_c('p',[_vm._v(_vm._s(_vm.form.reden.value))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }